/** @jsxImportSource @emotion/react */
import { css, jsx } from '@emotion/react';
import { Button } from 'components/Button/Button';
import { PageCard } from 'components/Card/PageCard';
import { PageCnt } from 'components/Card/PageCnt';
import { EditorText } from 'components/EditorText';
import { Footer } from 'components/Footer/Footer';
import { WithSidebar } from 'components/Sidebar/Sidebar';
import { SimulatorHeader } from 'components/SimulatorHeader/SimulatorHeader';
import { ReactComponent as ExcelIcon } from 'assets/microsoft_excel.svg';
import { TileTitle } from 'components/Titles/TileTitle';
import keys from 'i18n/keys';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTitle } from 'react-use';
import { SExcelBtn, SImgCol, STitle, STopSection } from './styles';

export const Introduction = () => {
  const { t } = useTranslation();
  useTitle(t(keys.INTRODUCTION_TOP_TEXT_title));
  return (
    <div>
      <WithSidebar>
        <PageCnt>
          <SimulatorHeader title={''} />
          <div
            css={css`
              padding-left: 100px;
            `}
          >
            <STopSection>
              <div>
                <STitle>{t(keys['INTRODUCTION_TOP_TEXT_title'])}</STitle>
                <EditorText
                  css={css`
                    margin-bottom: 52px;
                  `}
                  dangerouslySetInnerHTML={{ __html: t(keys.INTRODUCTION_TOP_TEXT) }}
                ></EditorText>
                {/* <SExcelBtn variant="primary" href={t(keys.XLS_CURRENT_DOWNLOAD_PATH)}>
                  <ExcelIcon />
                  <span>{t(keys.DOWNLOAD_EXCEL_TEXT)}</span>
                </SExcelBtn> */}
              </div>
              <SImgCol>
                <img
                  src="/images/Device - Macbook Air.png"
                  width="607px"
                  height="375px"
                  alt="Zrzut ekranu symulatora"
                />
              </SImgCol>
            </STopSection>
            <div
              css={css`
                max-width: 700px;
                margin: 0 auto;
              `}
            >
              <EditorText dangerouslySetInnerHTML={{ __html: t(keys.INTRODUCTION_DESCRIPTION_TEXT) }}></EditorText>
            </div>
          </div>
        </PageCnt>
      </WithSidebar>
    </div>
  );
};
